import { Grid2 } from '@aibees/shared/components';
import { PlanDetailProvider } from '@aibees/shared/features/price-and-plan/components/plan-detail/context';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { HowCreditsWork } from './components/how-credits-work';
import { SubscriptionPlans } from './components/subscription-plans';
import * as Styled from './styles';
import * as SX from './sx';
import type { PlanDetailProps as Props } from './types';

export const PlanDetail = memo(({ className }: Props) => {
  return (
    <PlanDetailProvider>
      <Styled.Wrapper
        className={classnames('PlanDetail', className)}
        sx={SX.root}
      >
        <Grid2 container spacing={2} columns={48}>
          <Grid2 sx={SX.column} xs={48} sm={48} md={48} lg={36} xl={34}>
            <SubscriptionPlans />
          </Grid2>
          <Grid2 sx={SX.column} xs={48} sm={48} md={48} lg={12} xl={14}>
            <HowCreditsWork />
          </Grid2>
        </Grid2>
      </Styled.Wrapper>
    </PlanDetailProvider>
  );
});

PlanDetail.displayName = 'PlanDetail';
